const urls = {
  addressUrls: {
    ADDRESS: '/address/',
    ADDRESS_CITY: '/address/city/',
    ADDRESS_DISTRICT: '/address/district/',
    ADDRESS_LIST: '/address/detailed/',
    ADDRESS_TOWNSHIP: '/address/township/',
  },
  basketUrls: {
    BASKET: '/baskets/basket/',
    BASKET_ITEMS: '/baskets/basket_items/',
  },
  checkoutUrls: {
    CHECKOUT_BASE: '/orders/checkout/',
  },
  contactUrls: {
    CONTACT_US: '/users/contact-us/',
    CONTACT_US_SUBJECTS: '/users/contact-us-subjects/',
  },
  couponUrls: {
    BASKET_OFFERS: '/account/basket-offers/',
    DISCOUNT_ITEMS: '/account/discount-items/',
    EXPIRED_BASKET_OFFERS: '/account/expired-basket-offers/',
    FUTURE_BASKET_OFFERS: '/account/future-basket-offers/',
  },
  favouriteUrls: {
    FAVOURITE: '/wishlists/favourite-products/',
  },
  miscUrls: {
    CSRF_TOKEN: '/csrf_token/',
    SEARCH_AUTOCOMPLETE: '/autocomplete/',
    STORES: '/stores/',
    SUBSCRIPTION: '/subscriptions/',
    MENU: '/menus/generate/',
  },
  orderUrls: {
    ORDERS: '/users/orders/',
    CANCELLATION_REASONS: '/users/orders/cancellation_reasons/',
    CANCELLATION_REQUEST: '/users/orders/cancellation_requests/',
    AUTO_CANCELLATION_REQUEST: '/orders/$0/cancel/',
  },
  productUrls: {
    PRODUCT: '/product/',
    PRODUCT_LIST: '/list/',
    PRODUCT_GET_NOTICE: '/wishlists/product-alerts/',
    PRODUCT_PRICE_NOTICE: '/wishlists/price-alerts/',
  },
  userUrls: {
    CURRENT_USER: '/current_user/',
    LOGIN: '/users/login/',
    LOGOUT: '/users/logout/',
    REGISTER: '/users/register/',
    EMAIL_CHANGE: '/users/email-change/',
    PASSWORD_CHANGE: '/users/password/change/',
    PASSWORD_RESET: '/users/password/reset/',
    PROFILE: '/users/profile/',
    GUEST_LOGIN: '/orders/checkout/?page=IndexPage',
  },
  giftUrls: {
    GIFT_ADD: '/orders/checkout/?page=GiftBoxPage',
    GIFT_REMOVE: '/orders/checkout/?page=GiftBoxIndexPage',
  },
};
export default {
  setter: (scope, url, value) => {
    urls[scope][url] = value;
  },
  ...urls.addressUrls,
  ...urls.basketUrls,
  ...urls.checkoutUrls,
  ...urls.contactUrls,
  ...urls.couponUrls,
  ...urls.favouriteUrls,
  ...urls.miscUrls,
  ...urls.orderUrls,
  ...urls.productUrls,
  ...urls.userUrls,
  ...urls.giftUrls,
};